import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import React, { useImperativeHandle } from 'react';
const Checkbox = React.forwardRef(({ label, value, className, id, ...rest }, ref) => {
    const checkboxRef = React.useRef(null);
    useImperativeHandle(ref, () => checkboxRef.current);
    return (_jsxs("label", { className: clsx('flex cursor-pointer items-center', className), htmlFor: id, children: [_jsx("input", { type: "checkbox", ref: checkboxRef, className: "form-checkbox rounded-base text-violet-60 mr-small border-grey-30 h-[20px] w-[20px] focus:ring-0", value: value, id: id, ...rest }), label] }));
});
export default Checkbox;
//# sourceMappingURL=index.js.map